import { useEffect, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";

import CustomAppleAuth from "../../../common/CustomAppleAuth";
import CustomGoogleAuth from "../../../common/CustomGoogleAuth";
import CustomButton from "../../../common/CustomButton";
import CustomActionButton from "../../../common/CustomActionButton";
import CustomInput from "../../../common/CustomInput";
import CustomLoader from "../../../common/CustomLoader";

import { FillEye, FillEyeSlash } from "../../../common/CustomIcons";
import { validations } from "../../../constants";
import { apiCallV2 } from "../../../utils/api";
import { delay } from "../../../utils";
import { SetUserDetails, CheckRequirementsAndRedirectV2, LoadUserData, LoadUserBillingData, LoadFavorites, LoadFinishedWorkoutsIDs, LoadAccountDetails } from "../../../redux/v2/user/actions";

import "../style.css";
import "./style.css";
import Logout from "../../../common/Logout";

const Login = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { invitationDetails } = props.User;

    window?.callIdentify?.();

    const offer = searchParams.get("offer");

    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setErrorMessage] = useState("");
    const [passwordError, setpasswordError] = useState("");
    const [loading, setLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (invitationDetails?.signupType == "therapistinvite") {
            navigate("/user-onboarding/0");
        }
    }, [invitationDetails]);

    const onChangeUserName = (event) => {
        setUserName(event.target.value);
        if (userName == "") {
            setErrorMessage("");
        }
        if (error != "" && validations.usernameRegex.test(userName)) {
            setErrorMessage("");
        }
    };

    const onChangePassword = (event) => {
        setPassword(event.target.value);
        if (password === "") {
            setpasswordError("");
        }
    };

    const onClickLogin = async () => {
        if (userName.trim() === "") {
            // setErrorMessage(validations.usernameValidation);
        } else if (password === "") {
            setpasswordError(validations.passwordValidation);
        } else {
            setErrorMessage("");
            setpasswordError("");
            const res = await apiCallV2("POST", "login", {
                user_name: userName,
                password: password,
                user_type: 2, //1 is customer,0 is admin
            });
            if (res && res.data.status === 200) {
                const requirementStatus = res.data.data.requirement_status;

                localStorage.setItem("access-token", res.data.data.access_token);
                localStorage.setItem("email", res.data.data.email_address);
                localStorage.setItem("username", res.data.data.email_address);
                localStorage.setItem("requirement_status", requirementStatus);
                localStorage.setItem("launchDate", res.data.data.launchDate);
                localStorage.setItem(
                    "indi-new-user-details",
                    JSON.stringify({
                        name: {
                            first: res.data.data.first_name,
                            last: res.data.data.last_name,
                        },
                    })
                );

                props.LoadAccountDetails();
                props.LoadUserData();
                props.LoadUserBillingData();
                props.LoadFavorites();
                props.LoadFinishedWorkoutsIDs();

                props.SetUserDetails(res.data.data);

                const saleID = localStorage.getItem("sale-id");
                if (saleID && saleID != "null" && saleID != null) {
                    navigate("/plan-sale?sale-id=" + saleID);
                } else {
                    props.CheckRequirementsAndRedirectV2(navigate);
                }
                return true;
            } else {
                toast.error(res.data.message);
                return false;
            }
        }
    };

    const dt = localStorage.getItem("indi-device-type");
    const platform = localStorage.getItem("indi-platform");
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");

    return (
        <>
            <Logout showLogo showLogout={false} />
            <div id="login-area" className="auth-box" style={{ padding: "30px 0" }}>
                <div className="container">
                    <div className="auth-form login-form">
                        <h2 className="title-txt text-md-left">Log In</h2>
                        <form>
                            <div className="form-group">
                                <div className="d-flex align-items-center">
                                    <CustomInput
                                        placeholder="USERNAME OR EMAIL"
                                        style={{
                                            borderColor: error == "" ? "lightgrey" : "red",
                                        }}
                                        type="text"
                                        value={userName}
                                        name="userName"
                                        onChange={(event) => onChangeUserName(event)}
                                        className="i-box"
                                    />
                                </div>
                                {error != "" && <p className="error">{error}</p>}
                            </div>
                            <div className="form-group">
                                <div className="d-flex align-items-center">
                                    <div className="position-relative i-box">
                                        <CustomInput
                                            placeholder="PASSWORD"
                                            autoComplete="new-password"
                                            style={{
                                                borderColor: passwordError == "" ? "lightgrey" : "red",
                                            }}
                                            value={password}
                                            name="password"
                                            onChange={(event) => onChangePassword(event)}
                                            type={isVisible ? "text" : "password"}
                                        />
                                        <button onClick={() => setIsVisible(!isVisible)} type="button" className="btn btn-light icon-right">
                                            {isVisible ? <FillEye /> : <FillEyeSlash />}
                                        </button>
                                    </div>
                                </div>
                                {passwordError != "" && <p className="error">{passwordError}</p>}
                            </div>
                            <div className="text-center" style={{ padding: "20px 0", marginBottom: "10px" }}>
                                <CustomActionButton action={onClickLogin} type={2}>
                                    Log in
                                </CustomActionButton>
                            </div>

                            <h5 className="e-text reset-link">
                                <Link to={"/reset-password"}>Forgot Password?</Link>
                            </h5>

                            <h5 className="e-text reset-link">
                                Don’t Have an Account? <Link to={"/signup"}>Register Here</Link>.
                            </h5>
                            {/* 
                            {!isUsingApp ? (
                                <p className="e-text">
                                    Don't have an account? <Link to={"/signup"}>Sign Up</Link>.
                                </p>
                            ) : (
                                ""
                            )} */}
                        </form>

                        <div className="login-btn-wrapper">
                            <Box sx={{ m: "auto" }}>
                                <CustomAppleAuth authType="signin" />
                            </Box>
                            <Box sx={{ m: "auto" }}>
                                <CustomGoogleAuth authType="signin" />
                            </Box>
                        </div>
                    </div>
                </div>
                {loading && <CustomLoader loading={loading} />}
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    SetUserDetails,
    CheckRequirementsAndRedirectV2,
    LoadUserData,
    LoadUserBillingData,
    LoadFavorites,
    LoadFinishedWorkoutsIDs,
    LoadAccountDetails,
})(Login);
